export enum Mode {
  LIGHT = 'light',
  DARK = 'dark',
}
